export const validate_id = (id_input) => {
    var month = parseInt(id_input.substring(2, 4), 10) - 1;
    var day = parseInt(id_input.substring(4, 6), 10);
    var id_year = parseInt(id_input.substring(0, 2), 10);

    if (month < 0 || month > 11) {
    return false;
    }

    if (day < 1 || day > 31) {
    return false;
    }

    if (id_year < new Date().getFullYear() - 100) {
    id_year += 2000;
    } else {
    id_year += 1900;
    }

    var temp_date = new Date(id_year, month, day);
    var id_date = temp_date.getDate();
    var id_month = temp_date.getMonth();

    if (id_month !== month || id_date !== day) {
    return false;
    }

    var check_sum = 0;
    var multiplier = 1;

    for (var i = 0; i < 13; i++) {
    var digit = parseInt(id_input.charAt(i), 10);
    var temp_total = digit * multiplier;

    if (temp_total > 9) {
        temp_total = parseInt(temp_total.toString().charAt(0), 10) + parseInt(temp_total.toString().charAt(1), 10);
    }

    check_sum += temp_total;
    multiplier = (multiplier % 2 === 0) ? 1 : 2;
    }

    if ((check_sum % 10) !== 0) {
    return false;
    }

    return true;
};

export const allow_character = (event) => {
  // Allow only letters, spaces, and hyphens (no numbers)
  let character_value = event.target.value.replace(/[^a-zA-Z\s-]/g, '');
  event.target.value = character_value;
  return character_value;
};

/**
 * Validate South African ID number using Luhn algorithm
 * @param {string} id_number - The ID number to validate
 * @returns {object} - {isValid: boolean, message: string}
 */
export const validate_south_african_id = (id_number) => {
  if (!id_number) {
    return { isValid: false, message: "ID number is required" };
  }
  
  // Remove spaces and check if it's only digits
  id_number = String(id_number).trim().replace(/\s/g, '');
  
  if (!/^\d+$/.test(id_number)) {
    return { isValid: false, message: "ID number must contain only numbers" };
  }
  
  if (id_number.length !== 13) {
    return { isValid: false, message: "ID number must not exceed 13 digits" };
  }
  
  // Luhn algorithm validation
  const luhn_checksum = (card_number) => {
    const digits = String(card_number).split('').map(d => parseInt(d, 10));
    const odd_digits = digits.filter((_, i) => i % 2 === 0).reverse();
    const even_digits = digits.filter((_, i) => i % 2 !== 0).reverse();
    
    let checksum = odd_digits.reduce((sum, d) => sum + d, 0);
    
    for (const d of even_digits) {
      const doubled = d * 2;
      checksum += doubled > 9 ? Math.floor(doubled / 10) + (doubled % 10) : doubled;
    }
    
    return checksum % 10;
  };
  
  if (luhn_checksum(id_number) !== 0) {
    return { isValid: false, message: "Invalid ID number" };
  }
  
  return { isValid: true, message: "", value: id_number };
};

/**
 * Validate South African company registration number
 * @param {string} reg_number - The company registration number to validate
 * @returns {object} - {isValid: boolean, message: string, value: string}
 */
export const validate_company_registration = (reg_number) => {
  if (!reg_number) {
    return { isValid: false, message: "Company registration number is required" };
  }
  
  // Remove spaces and convert to uppercase
  reg_number = String(reg_number).trim().toUpperCase().replace(/\s/g, '');
  
  // South African company registration formats:
  // Format 1: YYYY/NNNNNN/NN (e.g., 2018/123456/07)
  const pattern1 = /^\d{4}\/\d{6}\/\d{2}$/;
  // Format 2: CK format (CKNNNN/NNNNNN/NN)
  const pattern2 = /^CK\d{4}\/\d{6}\/\d{2}$/;
  // Format 3: Without slashes - exactly 12 digits (YYYYNNNNNNNN)
  const pattern3 = /^\d{12}$/;
  
  if (pattern1.test(reg_number) || pattern2.test(reg_number)) {
    return { isValid: true, message: "", value: reg_number };
  } else if (pattern3.test(reg_number)) {
    // Format it properly: YYYY/NNNNNN/NN
    const formatted = `${reg_number.slice(0, 4)}/${reg_number.slice(4, 10)}/${reg_number.slice(10, 12)}`;
    return { isValid: true, message: "", value: formatted };
  } else {
    return { 
      isValid: false, 
      message: "Invalid company registration format. Expected: YYYY/NNNNNN/NN or 12 digits" 
    };
  }
};

/**
 * Validate date of birth in YYYY/MM/DD format
 * @param {string} date_value - The date of birth to validate
 * @returns {object} - {isValid: boolean, message: string, value: string}
 */
export const validate_date_of_birth_with_slashes = (date_value) => {
  if (!date_value) {
    return { isValid: false, message: "Date of birth is required" };
  }
  
  // Remove spaces
  date_value = String(date_value).trim().replace(/\s/g, '');
  
  // Check format YYYY/MM/DD
  const pattern = /^\d{4}\/\d{2}\/\d{2}$/;
  
  if (!pattern.test(date_value)) {
    return { 
      isValid: false, 
      message: "Invalid date format. Expected: YYYY/MM/DD" 
    };
  }
  
  // Split and validate the date parts
  const parts = date_value.split('/');
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);
  
  // Validate year (reasonable range: 1900 to current year)
  const current_year = new Date().getFullYear();
  if (year < 1900 || year > current_year) {
    return { 
      isValid: false, 
      message: `Year must be between 1900 and ${current_year}` 
    };
  }
  
  // Validate month (1-12)
  if (month < 1 || month > 12) {
    return { 
      isValid: false, 
      message: "Month must be between 01 and 12" 
    };
  }
  
  // Validate day (1-31, considering month)
  if (day < 1 || day > 31) {
    return { 
      isValid: false, 
      message: "Day must be between 01 and 31" 
    };
  }
  
  // Create a date object and check if it's valid
  const test_date = new Date(year, month - 1, day);
  
  if (test_date.getFullYear() !== year || 
      test_date.getMonth() !== month - 1 || 
      test_date.getDate() !== day) {
    return { 
      isValid: false, 
      message: "Invalid date (e.g., February 30th doesn't exist)" 
    };
  }
  
  // Check if date is not in the future
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (test_date > today) {
    return { 
      isValid: false, 
      message: "Date of birth cannot be in the future" 
    };
  }
  
  return { isValid: true, message: "", value: date_value };
};

export const allow_alpha_num = (event) => {
  // Allow letters, numbers, spaces, and hyphens
  let alpha_num_value = event.target.value.replace(/[^a-zA-Z0-9\s-]/g, '');
  event.target.value = alpha_num_value;
  return alpha_num_value;
};

export const allow_num = (event) => {
  
  let numeric_value = event.target.value.replace(/\D/g, '');
  event.target.value = numeric_value;
  return numeric_value;
};

export const allow_currency = (event) => {
  let currency_value = event.target.value.replace(/[^0-9.]/g, '');
  // Only allow one decimal point
  const parts = currency_value.split('.');
  if (parts.length > 2) {
    currency_value = parts[0] + '.' + parts.slice(1).join('');
  }
  event.target.value = currency_value;
  return currency_value;
};

export function validate_first_name(first_name) {
    if (!first_name.trim()) {
      $('.first-name-message').removeClass('d-none');
      setTimeout(() => {
        $('.first-name-message').addClass('d-none');
      }, 3000);
      return false;
    }
    return true;
  }

// Last name validation
export function validate_last_name(last_name) {
  if (!last_name.trim()) {
    $('.last-name-message').removeClass('d-none');
    setTimeout(() => {
      $('.last-name-message').addClass('d-none');
    }, 3000);
    return false;
  }
  return true;
}

// Email validation
export function validate_email(email) {
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  if (!email.trim()) {
    $('.email-message').text('Email is required').removeClass('d-none');
    setTimeout(() => {
      $('.email-message').addClass('d-none');
    }, 3000);
    return false;
  }
  
  if (!EMAIL_PATTERN.test(email)) {
    $('.email-message').text('Please enter a valid email address').removeClass('d-none');
    setTimeout(() => {
      $('.email-message').addClass('d-none');
    }, 3000);
    return false;
  }
  
  return true;
}

// Phone number validation
export function validate_phone_number(phone_number) {
  const PHONE_PATTERN = /^\d{10}$/;
  phone_number = phone_number.replace(/\D/g, '');

  if (phone_number.length === 10 && PHONE_PATTERN.test(phone_number)) {
    return true;
  } else {
    $('.phone-number-message').removeClass('d-none');
    setTimeout(() => {
      $('.phone-number-message').addClass('d-none');
    }, 3000);
    return false;
  }
}

// Name validation (for removing invalid characters)
export function validate_name(input_value) {
  return input_value.replace(/[^a-zA-Z\s]/g, '');
}

//password match validation
export function password_match(password,confirm_password) {
  if (password !== confirm_password) {
    $('.match-password-message').removeClass('d-none');
  } else {
      $('.match-password-message').addClass('d-none');
  }
}

//email match validation
export function email_match(email,confirm_email){
  if (email !== confirm_email) {
    $('.email-match-message').removeClass('d-none');
  } else {
      $('.email-match-message').addClass('d-none');
  }
}

// checks if password field is empty
export function password_check(password){
  if (!password.trim()) {
    $('.password-message').removeClass('d-none');
    setTimeout(() => {
        $('.password-message').addClass('d-none');
    }, 3000);
  }
}

// check if confirm_password field is empty
export function confirm_password_check(confirm_password){
  if (!confirm_password.trim()) {
    $('.confirm-password-message').removeClass('d-none');
    setTimeout(() => {
        $('.confirm-password-message').addClass('d-none');
    }, 3000);
  }
}

export function validate_dynamic_inputs(dynamic_fields){
  for (const field of dynamic_fields) {
    if (!field.value.trim()) {
      this.show_error(`.${field.name}-message`, `Please fill in your ${field.placeholder}`);
    }
  }

}

export function show_error(selector, message) {
  $(selector).text(message).removeClass('d-none');
  setTimeout(() => {
    $(selector).addClass('d-none');
  }, 3000);
}

export function validate_invalid_characters(field_value) {
  const name_pattern = /^[A-Za-z\s]*$/;
  if (field_value && !name_pattern.test(field_value)) {
    return field_value.replace(/[^A-Za-z\s]/g, '');
  }
  return field_value;
}

export function validate_gender(gender) {

   if (/\d/.test(gender)) {

    return '';
  }


  const valid_gender = ['M', 'F'];
  if (gender && !valid_gender.includes(gender.toUpperCase())) {

    return 'M';
  }

  return gender.toUpperCase();
}


export function validate_date_of_birth(date_of_birth, error_selector) {
  const error_element = document.querySelector(error_selector);


  if (!/^\d{8}$/.test(date_of_birth)) {
    error_element.classList.remove('d-none');
    return false;
  }

 
  const year = parseInt(date_of_birth.substring(0, 4), 10);
  const month = parseInt(date_of_birth.substring(4, 6), 10) - 1;
  const day = parseInt(date_of_birth.substring(6, 8), 10);


  const date = new Date(year, month, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month ||
    date.getDate() !== day
  ) {
    error_element.classList.remove('d-none');
    return false;
  }

  error_element.classList.add('d-none');
  return true;
}

export function validate_all_fields(fields, data, error_messages, default_message = 'This field is required') {
  let valid = true;

  fields.forEach((field) => {
    if (!data[field]) {
      error_messages[field] = default_message;
      valid = false;
    } else {
      error_messages[field] = '';
    }
  });

  return valid;
}

export function validate_registration_number(input, position) {
  const clean_input = input.replace(/\D/g, '');
  const reg1 = clean_input.slice(0, 4);
  const reg2 = clean_input.slice(4, 10);
  const reg3 = clean_input.slice(10);

  const formatted_registration = [reg1, reg2, reg3].filter(Boolean).join('/').slice(0, 14);

  return {
    formatted_registration,
      new_cursor_pos: position + (formatted_registration.length - input.length),
      reg1,
      reg2,
      reg3,
  };
}

export function format_business_registration_number(event) {
  // Remove all non-digit characters
  let input = event.target.value.replace(/\D/g, '');
  let cursor_position = event.target.selectionStart;

  // Handle backspace at the start of the input
  if (event.key === 'Backspace' && cursor_position === 0) return;

  // Format the input dynamically
  let formatted_input;
  if (input.length > 4 && input.length <= 10) {
    formatted_input = input.replace(/(\d{4})(\d{0,6})/, '$1/$2');
  } else if (input.length > 10) {
    formatted_input = input.replace(/(\d{4})(\d{0,6})(\d{0,2})/, '$1/$2/$3');
  } else {
    formatted_input = input;
  }

  // Limit the formatted input to 14 characters
  formatted_input = formatted_input.slice(0, 14);

  // Adjust the cursor position
  let new_cursor_position = cursor_position + (formatted_input.length - input.length);

  return {
    formatted_input,
    new_cursor_position,
  };
}

export const validate_country_code = (country_code) => {
  const country_code_regex = /^[A-Z]{3}$/;
  if (!country_code_regex.test(country_code)) {
      return false;
  }
  return true;
};

export const validate_document_number = (value) => {
  if (!value || value.trim() === '') return true; // optional
  value = value.trim();
  if (value.length !== 12) return false;
  if (!/^[A-Za-z0-9]{12}$/.test(value)) return false;
  const digits = value.split('').filter(c => /\d/.test(c)).length;
  const letters = value.split('').filter(c => /[a-zA-Z]/.test(c)).length;
  return digits === 11 && letters === 1;
};

export const validate_certificate_dob = (value) => {
  if (!value) return false; // required
  if (!/^\d{8}$/.test(value)) return false;
  const year = parseInt(value.substr(0, 4));
  const month = parseInt(value.substr(4, 2));
  const day = parseInt(value.substr(6, 2));
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day && date <= new Date();
};

export const validate_alphanumeric_with_spaces = (value, maxLength = 55) => {
  if (!value) return false;
  value = value.trim();
  if (!/^[A-Za-z0-9 ]+$/.test(value)) return false;
  return value.length <= maxLength;
};

export const validate_certificate_year = (value) => {
  if (!value) return false;
  if (!/^\d{4}$/.test(value)) return false;
  const year = parseInt(value);
  const currentYear = new Date().getFullYear();
  return year >= 1900 && year <= currentYear;
};

export const validate_qualification = (value) => {
  if (!value) return false;
  const allowed = ["11", "12", "21", "22", "31", "32", "41", "42", "51", "52", "61", "71", "72", "81", "82", "91"];
  return allowed.includes(String(value));
};

export const validate_subject_code = (value) => {
  if (!value || value.trim() === '') return true; // optional
  return /^\d{4}$/.test(value);
};

export const validate_subject_performance = (value) => {
  if (!value || value.trim() === '') return true;
  return /^[A-Za-z0-9]{2}$/.test(value);
};

export const is_valid_email = (email) => {
  if (!email || !email.trim()) return false;
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return EMAIL_PATTERN.test(email);
};

export const is_valid_phone_number = (phone_number) => {
  if (!phone_number) return false;
  const cleaned = phone_number.replace(/\D/g, '');
  return cleaned.length >= 10 && cleaned.length <= 15;
};

export const is_valid_registration_number = (reg_number) => {
  if (!reg_number) return false;
  const REG_PATTERN = /^\d{4}\/\d{6}\/\d{2}$/;
  return REG_PATTERN.test(reg_number);
};

export const validate_namibian_id = (id_number) => {
  if (!id_number) return false;
  
  id_number = String(id_number).trim().replace(/\s/g, '');
  
  if (!/^\d+$/.test(id_number)) {
    return false;
  }
  
  if (id_number.length < 11 || id_number.length > 13) {
    return false;
  }
  
  return true;
};

export const validate_passport = (passport_number) => {
  if (!passport_number) return false;
  
  passport_number = String(passport_number).trim().toUpperCase().replace(/\s/g, '');
  
  // Passport: alphanumeric, 6-20 characters
  const passport_regex = /^[A-Z0-9]{6,20}$/;
  return passport_regex.test(passport_number);
};